import { render, staticRenderFns } from "./avalonAccordionSettings.vue?vue&type=template&id=4a2e6a66&scoped=true&"
import script from "./avalonAccordionSettings.vue?vue&type=script&lang=js&"
export * from "./avalonAccordionSettings.vue?vue&type=script&lang=js&"
import style0 from "./avalonAccordionSettings.vue?vue&type=style&index=0&id=4a2e6a66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2e6a66",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VDivider,VHover,VIcon,VSheet})
